import type { IceRecoveryLadder, IceRestartDecision } from 'utils/webrtc/IceRecoveryLadder';

type IceRestartConfigResult =
  { ok: true; relayRequested: boolean } | { ok: false; relayRequested: boolean; error: unknown };

// Must run before the restart's createOffer: Firefox ignores a configuration change made after it.
export const applyIceRestartConfig = (
  pc: RTCPeerConnection,
  ladder: IceRecoveryLadder,
  decision: IceRestartDecision,
  { relayFallback, iceServers }: { relayFallback: boolean; iceServers?: RTCIceServer[] | null }
): IceRestartConfigResult => {
  const relayRequested = decision.relay && relayFallback;
  const switchToRelay = relayRequested && !ladder.isRelayActive;

  if (!iceServers && !switchToRelay) {
    return { ok: true, relayRequested };
  }

  try {
    pc.setConfiguration({
      ...pc.getConfiguration(),
      ...(iceServers ? { iceServers } : {}),
      ...(switchToRelay ? { iceTransportPolicy: 'relay' as const } : {}),
    });
  } catch (error) {
    return { ok: false, relayRequested, error };
  }

  if (switchToRelay) {
    ladder.markRelayActive();
  }

  return { ok: true, relayRequested };
};
